var _rect, _path, _path2, _g, _g2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiwaliOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#F8E1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30 L800 30",
    stroke: "#5652B0",
    strokeWidth: 2,
    strokeDasharray: "6 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 170 L800 170",
    stroke: "#5652B0",
    strokeWidth: 2,
    strokeDasharray: "6 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -20 L0 -40",
    stroke: "#F44336",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -40,
    r: 5,
    fill: "#F44336"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720, 90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -20 L0 -40",
    stroke: "#F44336",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -40,
    r: 5,
    fill: "#F44336"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 30,
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 25,
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 20,
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 15,
    fill: "#FFD700"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 100,
    r: 30,
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 100,
    r: 25,
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 100,
    r: 20,
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 100,
    r: 15,
    fill: "#FFD700"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#5652B0",
    textAnchor: "middle"
  }, "DIWALI OFFER")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#5652B0",
    textAnchor: "middle"
  }, "10% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#333",
    textAnchor: "middle"
  }, "Celebrate the festival of lights with special savings!")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiwaliOffer);
export default __webpack_public_path__ + "static/media/diwali_offer.45b0496dfb558ea7986ed1675e390ec4.svg";
export { ForwardRef as ReactComponent };